import {ParamsModel} from 'src/app/modules/common/Model'
import {LedgerModel} from '../Model/Model'
import {actionTypes} from './constants'

export const actions = {
  getAuditTrail: (params: ParamsModel = {page: 1, limit: 10}) => ({
    type: actionTypes.GET_AUDIT_TRAIL_START,
    payload: params,
  }),
  getAuditTrailSuccess: (data: LedgerModel | any) => ({
    type: actionTypes.GET_AUDIT_TRAIL_SUCCESS,
    payload: data,
  }),
  getAuditTrailFinish: () => ({
    type: actionTypes.GET_AUDIT_TRAIL_FINISH,
  }),
  getAuditTrailFilterOptions: () => ({
    type: actionTypes.GET_AUDIT_TRAIL_FILTER_OPTIONS_START,
  }),
  getAuditTrailFilterOptionsSuccess: (data: any) => ({
    type: actionTypes.GET_AUDIT_TRAIL_FILTER_OPTIONS_SUCCESS,
    payload: data,
  }),
  getAuditTrailFilterOptionsFinish: () => ({
    type: actionTypes.GET_AUDIT_TRAIL_FILTER_OPTIONS_FINISH,
  }),
}
